module.exports = __webpack_public_path__ + "static/img/faq_about02.1080717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_about02.png
// module id = gtGq
// module chunks = 2